<script setup lang="ts">
import DashboardSparkline from './DashboardSparkline.vue'

defineProps<{
    label: string
    value: string | number
    sub?: string | null
    sparklineValues?: number[] | null
    icon?: any
}>()
</script>

<template>
    <div class="bg-white border border-gray-100 rounded-xl shadow-sm p-4 flex flex-col gap-1 hover:shadow-md hover:border-gray-300 transition-all duration-100">
        <div class="flex items-center justify-between mb-1">
            <div class="text-xs text-gray-500 font-medium">{{ label }}</div>
            <component v-if="icon" :is="icon" class="w-4 h-4 text-gray-400" />
        </div>
        <div class="text-2xl font-bold text-ink tabular-nums leading-tight">{{ value }}</div>
        <div v-if="sub" class="text-[10px] text-gray-500 font-medium uppercase tracking-wider mt-0.5">{{ sub }}</div>
        <div v-if="sparklineValues && sparklineValues.length > 0" class="mt-1 -mx-1">
            <DashboardSparkline :values="sparklineValues" />
        </div>
    </div>
</template>
